import Alpine from 'alpinejs';

window.Alpine = Alpine;
Alpine.start();

// function desktopMenu() {
//     return {
//         open: false,
//         moreOpen: false,
//         overflowItems: [],
//
//         init() {
//             this.$nextTick(() => {
//                 this.checkOverflow()
//                 window.addEventListener('resize', () => this.checkOverflow())
//             })
//         },
//
//         checkOverflow() {
//             const container = this.$refs.menu
//             const more = this.$refs.more
//             // všechny položky kromě dropdownu "VÍCE"
//             const items = Array.from(container.children).filter(el => el !== more)
//             const available = container.clientWidth - more.offsetWidth
//
//             let used = 0
//             this.overflowItems = []
//
//             items.forEach(el => {
//                 el.style.display = ''  // reset
//             })
//
//             for (let el of items) {
//                 used += el.offsetWidth
//                 if (used > available) {
//                     this.overflowItems.push(el.outerHTML)
//                     el.style.display = 'none'
//                 }
//             }
//
//             // zobrazit/nechat skryt dropdown "VÍCE"
//             more.style.display = this.overflowItems.length ? '' : 'none'
//         }
//     }
// }
